module.exports = __webpack_public_path__ + "static/media/gina-logo.35afb174.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/gina-logo.svg
 ** module id = 1300
 ** module chunks = 0
 **/